import styled, { css } from 'styled-components';
import { pxToRem } from '@anwb/style-utilities';
/**
 * Grid aside
 */
export const gridContainerAsidetyles = () => css ``;
export const GridContainerAside = styled.aside `
	${gridContainerAsidetyles}
`;
export const gridContainerAsideContentStyles = ({ theme, $isSticky, }) => css `
	${$isSticky &&
    css `
		position: sticky;
		top: ${pxToRem(theme.spacing['300'])};
	`}
`;
export const GridContainerAsideContent = styled.div `
	${gridContainerAsideContentStyles}
`;
//# sourceMappingURL=gridAside.styled.js.map